export class SubnetConfig {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "mode",
            "baseName": "mode",
            "type": "SubnetConfigModeEnum",
            "format": ""
        },
        {
            "name": "name",
            "baseName": "name",
            "type": "string",
            "format": ""
        },
        {
            "name": "addressPrefix",
            "baseName": "addressPrefix",
            "type": "string",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return SubnetConfig.attributeTypeMap;
    }
    constructor() {
    }
}
export var SubnetConfigModeEnum;
(function (SubnetConfigModeEnum) {
    SubnetConfigModeEnum["Existing"] = "existing";
    SubnetConfigModeEnum["Create"] = "create";
})(SubnetConfigModeEnum || (SubnetConfigModeEnum = {}));
